import {PROFILE_ACTION} from "../helper/constant";


export const controlBottom = () => dispatch => {
dispatch(
    {
        type: PROFILE_ACTION.BOTTOM_CONTROL,
        payload: true
    }
)
}

export const secControlBottom = () => dispatch => {

    dispatch(
        {
            type: PROFILE_ACTION.SEC_BOTTOM_CONTROL,
            payload: false
        }
    )
}
